'use strict';

var clientSideValidation = require('./clientSideValidation');

/**
 * Handle "other" field visibility for checkboxes, radio buttons, and dropdowns
 * Generic function that works for both registration and edit flows
 * @param {jQuery} $element - The checkbox/radio/dropdown element
 * @param {Object} options - Optional configuration
 * @param {number} options.currentStep - Current step number (for step-specific logic)
 * @param {jQuery} options.$form - Form jQuery object (for scoping)
 */
function handleOtherField($element, options) {
    var opts = options || {};
    var currentStep = opts.currentStep;
    var $form = opts.$form || $('form');

    if (!$element || $element.length === 0) {
        return;
    }

    var otherFieldId = $element.data('other-field');
    var otherGroupClass = $element.data('other-group');

    if (!otherFieldId || !otherGroupClass) {
        return;
    }

    var $otherGroup = $form.find('.' + otherGroupClass);
    var $otherField = $form.find('#' + otherFieldId);

    if ($otherGroup.length === 0 || $otherField.length === 0) {
        return;
    }

    // Check if "other" is selected - works for checkboxes, radios, and dropdowns
    var isOtherSelected = false;
    if ($element.is('select')) {
        isOtherSelected = $element.val() === 'other';
    } else {
        isOtherSelected = $element.is(':checked') && $element.val() === 'other';
    }

    if (isOtherSelected) {
        // Special handling for journey-other-group: only show on step 1 (registration flow)
        // In edit flow (currentStep is undefined), always show it
        if (otherGroupClass === 'journey-other-group' && currentStep !== undefined && currentStep !== 1) {
            $otherGroup.removeClass('show').addClass('visually-hidden');
            $otherField.prop('required', false);
            return;
        }

        // Special handling for influencer-point-of-sale-other-group:
        // Only show if "where-do-you-sell-group" is visible (i.e., "Do you sell creations?" is answered "Yes")
        if (otherGroupClass === 'influencer-point-of-sale-other-group') {
            var $whereSellGroup = $form.find('.where-do-you-sell-group');
            if ($whereSellGroup.length === 0 || $whereSellGroup.hasClass('visually-hidden') || !$whereSellGroup.hasClass('show')) {
                $otherGroup.removeClass('show').addClass('visually-hidden');
                $otherField.prop('required', false).prop('disabled', true);
                return;
            }
        }

        $otherGroup.removeClass('visually-hidden').addClass('show');
        // Only set required if the field is actually mandatory (check if it has required attribute or is in a required form-group)
        // For social-platforms-other-group, the field is not mandatory, so don't set required
        if (otherGroupClass !== 'social-platforms-other-group') {
            $otherField.prop('required', true);
        }
        $otherField.prop('disabled', false);
    } else {
        $otherGroup.removeClass('show').addClass('visually-hidden');
        $otherField.prop('required', false).prop('disabled', true).val('');
    }
}

/**
 * Handle platform-specific handle URL fields visibility
 * Shows/hides handle URL fields based on social platform checkbox selection
 * @param {jQuery} $checkbox - The checkbox element
 * @param {Object} options - Optional configuration
 * @param {jQuery} options.$form - Form jQuery object (for scoping)
 */
function handlePlatformField($checkbox, options) {
    var opts = options || {};
    var $form = opts.$form || $('form');

    if (!$checkbox || $checkbox.length === 0) {
        return;
    }

    var platformFieldId = $checkbox.data('platform-field');
    if (!platformFieldId) {
        return;
    }

    var $platformField = $form.find('#' + platformFieldId);
    var $platformGroup = $form.find('[data-platform-field="' + platformFieldId + '"]');

    if ($platformField.length === 0 || $platformGroup.length === 0) {
        return;
    }

    var isChecked = $checkbox.is(':checked');

    if (isChecked) {
        $platformGroup.removeClass('visually-hidden').addClass('show');
        $platformField.prop('disabled', false);
        // Remove visually-hidden from checkbox input if it was added
        $checkbox.removeClass('visually-hidden');
    } else {
        $platformGroup.addClass('visually-hidden').removeClass('show');
        $platformField.prop('disabled', true).val('').removeClass('is-invalid');
        $platformGroup.find('.invalid-feedback').hide().html('');
        // Remove visually-hidden from checkbox input when unchecked (checkbox should be visible for user interaction)
        $checkbox.removeClass('visually-hidden');
    }
}

/**
 * Handle "Do you sell creations as well?" radio button change for influencer
 * Generic function that works for both registration and edit flows
 * @param {jQuery} $radioButton - The radio button element
 * @param {Object} options - Optional configuration
 * @param {jQuery} options.$form - Form jQuery object (for scoping)
 */
function handleSellCreationsChange($radioButton, options) {
    var opts = options || {};
    var $form = opts.$form || $('form');

    if (!$radioButton || $radioButton.length === 0) {
        return;
    }

    var whereSellGroupClass = $radioButton.data('where-sell-group');
    if (!whereSellGroupClass) {
        return;
    }

    // Find the where-do-you-sell group - scope to influencer step first, then fallback to form
    var $influencerStep = $radioButton.closest('.journey-step.step-2-influencer');
    var $whereSellGroup = $influencerStep.length > 0
        ? $influencerStep.find('.' + whereSellGroupClass)
        : $form.find('.' + whereSellGroupClass);

    if ($whereSellGroup.length === 0) {
        return;
    }

    var selectedValue = $radioButton.val();
    // Find other group - it's inside the influencer step (in the influencerQuestions template)
    var $otherGroup = $influencerStep.length > 0
        ? $influencerStep.find('.influencer-point-of-sale-other-group')
        : $form.find('.influencer-point-of-sale-other-group');

    var isShow = selectedValue === 'true' || selectedValue === 'yes';

    if (isShow) {
        // Show the "Where do you sell?" group
        $whereSellGroup.removeClass('visually-hidden').addClass('show');
        // Remove visually-hidden from all inputs and labels within the group
        $whereSellGroup.find('input, select, label').removeClass('visually-hidden');
        $whereSellGroup.find('input, select').prop('disabled', false);
        $whereSellGroup.find('.is-invalid').removeClass('is-invalid');
        $whereSellGroup.find('.invalid-feedback').hide().html('');

        // Handle "other" field visibility
        if ($otherGroup.length > 0) {
            var $otherCheckbox = $whereSellGroup.find('input[type="checkbox"][value="other"]');
            if ($otherCheckbox.is(':checked')) {
                $otherGroup.removeClass('visually-hidden').addClass('show');
                $otherGroup.find('textarea').prop('disabled', false);
            } else {
                $otherGroup.addClass('visually-hidden').removeClass('show');
                $otherGroup.find('textarea').prop('disabled', true).val('').removeClass('is-invalid');
                $otherGroup.find('.invalid-feedback').hide().html('');
            }
        }
    } else {
        // Hide the "Where do you sell?" group
        $whereSellGroup.removeClass('show').addClass('visually-hidden');
        $whereSellGroup.find('input, select').prop('disabled', true);
        $whereSellGroup.find('input[type="checkbox"]').prop('checked', false);
        $whereSellGroup.find('input[type="text"], textarea').val('').removeClass('is-invalid');
        $whereSellGroup.find('.invalid-feedback').hide().html('');

        // Hide and clear the "other" field
        if ($otherGroup.length > 0) {
            $otherGroup.addClass('visually-hidden').removeClass('show');
            $otherGroup.find('textarea').prop('disabled', true).val('').removeClass('is-invalid');
            $otherGroup.find('.invalid-feedback').hide().html('');
        }
    }
}

/**
 * Initialize "other" fields visibility on page load
 * Checks all checkboxes, radio buttons, and dropdowns for "other" selection
 * Also checks if "other" text fields have values and shows them accordingly
 * @param {jQuery} $form - Form jQuery object
 */
function initializeOtherFields($form) {
    // First, check all "other" text fields - if they have values, show them and ensure "other" option is checked
    $form.find('[data-other-group]').each(function () {
        var $otherGroup = $(this);
        var otherGroupClass = $otherGroup.data('other-group');
        if (!otherGroupClass) {
            return;
        }

        // Special handling for influencer-point-of-sale-other-group:
        // Only initialize if "where-do-you-sell-group" is visible (i.e., "Do you sell creations?" is answered "Yes")
        if (otherGroupClass === 'influencer-point-of-sale-other-group') {
            var $whereSellGroup = $form.find('.where-do-you-sell-group');
            if ($whereSellGroup.length === 0 || $whereSellGroup.hasClass('visually-hidden') || !$whereSellGroup.hasClass('show')) {
                // Ensure it's hidden if "where-do-you-sell-group" is not visible
                $otherGroup.addClass('visually-hidden').removeClass('show');
                $otherGroup.find('textarea, input[type="text"]').prop('disabled', true);
                return;
            }
        }

        var $otherTextField = $otherGroup.find('textarea, input[type="text"]');
        if ($otherTextField.length > 0 && $otherTextField.val() && $otherTextField.val().trim() !== '') {
            // Find the corresponding "other" checkbox/radio/dropdown
            var $otherOption = $form.find('input[data-other-group="' + otherGroupClass + '"], select[data-other-group="' + otherGroupClass + '"]');
            if ($otherOption.length > 0) {
                var fieldType = $otherOption.attr('type');
                var tagName = $otherOption.prop('tagName').toLowerCase();

                // Ensure "other" option is selected/checked
                if (fieldType === 'checkbox' || fieldType === 'radio') {
                    if (!$otherOption.is(':checked')) {
                        $otherOption.prop('checked', true);
                    }
                } else if (tagName === 'select' && $otherOption.val() !== 'other') {
                    $otherOption.val('other').trigger('change');
                }

                handleOtherField($otherOption.first(), { $form: $form });
            } else if (otherGroupClass !== 'influencer-point-of-sale-other-group') {
                // Fallback: if we can't find the option but the field has a value, show it anyway
                // But skip for influencer-point-of-sale-other-group if where-do-you-sell-group is hidden
                $otherGroup.removeClass('visually-hidden');
                $otherTextField.prop('disabled', false);
            }
        }
    });

    // Check all elements with data-other-checkbox or data-other-select that have "other" selected
    $form.find('[data-other-checkbox="true"], [data-other-select="true"]').each(function () {
        var $element = $(this);
        var otherGroupClass = $element.data('other-group');

        // Special handling for influencer-point-of-sale-other-group:
        // Only initialize if "where-do-you-sell-group" is visible
        if (otherGroupClass === 'influencer-point-of-sale-other-group') {
            var $whereSellGroup = $form.find('.where-do-you-sell-group');
            if ($whereSellGroup.length === 0 || $whereSellGroup.hasClass('visually-hidden') || !$whereSellGroup.hasClass('show')) {
                // Ensure the "other" group is hidden if "where-do-you-sell-group" is not visible
                var $otherGroup = $form.find('.influencer-point-of-sale-other-group');
                if ($otherGroup.length > 0) {
                    $otherGroup.addClass('visually-hidden').removeClass('show');
                    $otherGroup.find('textarea, input[type="text"]').prop('disabled', true);
                }
                return;
            }
        }

        var fieldType = $element.attr('type');
        var tagName = $element.prop('tagName').toLowerCase();
        var isOtherSelected = false;

        if (fieldType === 'checkbox' || fieldType === 'radio') {
            isOtherSelected = $element.is(':checked') && $element.val() === 'other';
        } else if (tagName === 'select') {
            isOtherSelected = $element.val() === 'other';
        }

        if (isOtherSelected) {
            handleOtherField($element, { $form: $form });
        }
    });

    // Initialize platform-specific handle URL fields
    $form.find('[data-platform-checkbox="true"]').each(function () {
        var $checkbox = $(this);
        if ($checkbox.is(':checked')) {
            handlePlatformField($checkbox, { $form: $form });
        }
    });
}

/**
 * Validate "other" fields in a form or container
 * @param {jQuery} $container - Container jQuery object (form or step container)
 * @returns {boolean} True if all "other" fields are valid
 */
function validateOtherFields($container) {
    var isValid = true;
    $container.find('[data-other-checkbox="true"]:checked, [data-other-select="true"]').each(function () {
        var $trigger = $(this);
        if ($trigger.val() === 'other') {
            var otherFieldId = $trigger.data('other-field');
            var $otherField = $('#' + otherFieldId);
            if ($otherField.length > 0 && $otherField.is(':visible') && !$otherField.hasClass('visually-hidden') && !$otherField.prop('disabled')) {
                if (!$otherField.val() || $otherField.val().trim() === '') {
                    isValid = false;
                    var otherErrorMsg = $otherField.data('missing-error') || 'Must not be blank';
                    clientSideValidation.functions.showFieldError($otherField[0], otherErrorMsg);
                }
            }
        }
    });
    return isValid;
}

/**
 * Create temporary form with visible fields for validation
 * @param {jQuery} $container - Container jQuery object (form or step container)
 * @returns {Object} Object with tempForm and fieldMapping
 */
function createTempFormForValidation($container) {
    // Get all visible form fields (exclude hidden fields)
    var $visibleFields = $container.find('input:visible, select:visible, textarea:visible')
        .not('.visually-hidden input, .visually-hidden select, .visually-hidden textarea')
        .not('[disabled]');

    // Create a temporary form element containing only visible fields
    var $tempForm = $('<form style="display:none;"></form>');
    var fieldMapping = [];

    $visibleFields.each(function () {
        var $originalField = $(this);
        var field = this;
        var $clonedField = $originalField.clone();

        // Preserve field value based on type
        if (field.type === 'checkbox' || field.type === 'radio') {
            $clonedField.prop('checked', $originalField.is(':checked'));
        } else {
            $clonedField.val($originalField.val());
        }

        // Preserve all validation attributes
        $clonedField.attr('required', $originalField.prop('required'));
        $clonedField.attr('pattern', $originalField.attr('pattern'));
        $clonedField.attr('min', $originalField.attr('min'));
        $clonedField.attr('max', $originalField.attr('max'));
        $clonedField.attr('minlength', $originalField.attr('minlength'));
        $clonedField.attr('maxlength', $originalField.attr('maxlength'));

        $tempForm.append($clonedField);
        fieldMapping.push({
            temp: $clonedField[0],
            original: field
        });
    });

    // Append temp form to body temporarily (required for checkValidity to work)
    $('body').append($tempForm);

    return {
        tempForm: $tempForm,
        fieldMapping: fieldMapping
    };
}

/**
 * Map validation errors from temporary form back to original fields
 * @param {Array} fieldMapping - Array of {temp, original} field mappings
 * @param {Object} options - Optional configuration
 * @param {boolean} options.skipRadio - Skip radio buttons (default: false)
 * @param {boolean} options.skipCheckbox - Skip checkboxes (default: false)
 */
function mapValidationErrors(fieldMapping, options) {
    var opts = options || {};
    var skipRadio = opts.skipRadio || false;
    var skipCheckbox = opts.skipCheckbox || false;

    fieldMapping.forEach(function (mapping) {
        var $tempField = $(mapping.temp);
        var $originalField = $(mapping.original);

        // Skip radio buttons if requested
        if (skipRadio && mapping.temp.type === 'radio') {
            return;
        }

        // Skip checkboxes if requested
        if (skipCheckbox && mapping.temp.type === 'checkbox') {
            return;
        }

        if (!$tempField[0].validity.valid) {
            var errorMessage = $tempField.data('missing-error')
                || $tempField.data('range-error')
                || $tempField.data('pattern-error')
                || $tempField.data('mismatch-error')
                || $tempField[0].validationMessage;

            if (errorMessage) {
                clientSideValidation.functions.showFieldError($originalField[0], errorMessage);
            }
        }
    });
}

/**
 * Show/hide journey-specific fields based on selected customer type
 * Shared function for both registration and edit flows
 * @param {string} customerType - Selected customer type
 * @param {jQuery} $form - Form jQuery object
 */
function showJourneyFields(customerType, $form) {
    var $formScope = $form || $('form');

    // Hide all journey step 2 fields
    $formScope.find('.journey-step.step-2-business, .journey-step.step-2-smallArtisan, .journey-step.step-2-influencer').addClass('visually-hidden');

    // Disable all fields in hidden journey steps
    $formScope.find('.journey-step.step-2-business, .journey-step.step-2-smallArtisan, .journey-step.step-2-influencer')
        .find('input[required], select[required], textarea[required]')
        .prop('disabled', true);

    // Show and enable fields for selected journey
    if (customerType === 'business') {
        $formScope.find('.journey-step.step-2-business').removeClass('visually-hidden')
            .find('input, select, textarea').prop('disabled', false);
    } else if (customerType === 'smallArtisan') {
        $formScope.find('.journey-step.step-2-smallArtisan').removeClass('visually-hidden')
            .find('input, select, textarea').prop('disabled', false);
    } else if (customerType === 'influencer') {
        var $influencerStep = $formScope.find('.journey-step.step-2-influencer');
        $influencerStep.removeClass('visually-hidden');
        // Remove visually-hidden from all inputs, selects, textareas, and labels
        $influencerStep.find('input, select, textarea, label').removeClass('visually-hidden');
        $influencerStep.find('input, select, textarea').prop('disabled', false);
        // Handle sell creations visibility - check if "true" is already selected
        var $sellCreationsRadio = $formScope.find('.journey-step.step-2-influencer input[name*="soMeSales"]:checked');
        if ($sellCreationsRadio.length > 0) {
            var sellCreationsValue = $sellCreationsRadio.val();
            // Check for 'true' (XML form value) or 'yes' (for backward compatibility)
            if (sellCreationsValue === 'true' || sellCreationsValue === 'yes') {
                handleSellCreationsChange($sellCreationsRadio, { $form: $formScope });
            }
        } else {
            // If no radio is checked, ensure pointOfSale fields are hidden
            var $whereSellGroup = $formScope.find('.where-do-you-sell-group');
            if ($whereSellGroup.length > 0) {
                $whereSellGroup.addClass('visually-hidden');
                $whereSellGroup.find('input, select').prop('disabled', true);
            }
            var $otherGroup = $formScope.find('.influencer-point-of-sale-other-group');
            if ($otherGroup.length > 0) {
                $otherGroup.addClass('visually-hidden');
                $otherGroup.find('textarea').prop('disabled', true);
            }
        }
    }

    // Step 3 fields are always visible
    $formScope.find('.journey-step.step-3').removeClass('visually-hidden')
        .find('input, select, textarea').prop('disabled', false);
}

/**
 * Handle customer type change - shared logic for registration and edit flows
 * @param {jQuery} $form - Form jQuery object
 * @param {Object} options - Configuration options
 * @param {number} options.currentStep - Current step number (for registration flow, undefined for edit flow)
 * @param {Function} options.onChangeCallback - Optional callback function called when customer type changes
 * @param {boolean} options.showJourneyFieldsOnChange - Whether to show/hide journey fields on change (default: true for edit flow, false for registration)
 */
function handleCustomerTypeChange($form, options) {
    var opts = options || {};
    var currentStep = opts.currentStep;
    var onChangeCallback = opts.onChangeCallback;
    var showJourneyFieldsOnChange = opts.showJourneyFieldsOnChange !== false && currentStep === undefined;

    $form.on('change', 'input[name*="customerType"]', function () {
        var customerType = $(this).val();

        // Show/hide journey fields (only for edit flow, not registration step-based flow)
        if (showJourneyFieldsOnChange) {
            showJourneyFields(customerType, $form);
        }

        // Handle "other" field visibility
        var $otherRadio = $form.find('input[name*="customerType"][value="other"]');
        if ($otherRadio.length > 0) {
            // For registration flow, only show on step 1
            if (currentStep !== undefined && currentStep !== 1) {
                var $journeyOtherGroup = $form.find('.journey-other-group');
                $journeyOtherGroup.removeClass('show').addClass('visually-hidden');
            } else {
                handleOtherField($otherRadio, { currentStep: currentStep, $form: $form });
            }
        }

        // Call optional callback
        if (onChangeCallback && typeof onChangeCallback === 'function') {
            onChangeCallback(customerType);
        }
    });
}

/**
 * Initialize common event handlers for journey forms
 * Sets up handlers for "other" fields and "sell creations" radio
 * @param {jQuery} $form - Form jQuery object
 * @param {Object} options - Configuration options
 * @param {number} options.currentStep - Current step number (for registration flow)
 */
function initializeJourneyFormHandlers($form, options) {
    var opts = options || {};
    var currentStep = opts.currentStep;

    // Generic "other" checkbox/radio/dropdown handler
    $form.on('change', '[data-other-checkbox="true"], [data-other-select="true"]', function () {
        handleOtherField($(this), { currentStep: currentStep, $form: $form });
    });

    // Handle platform-specific handle URL fields
    $form.on('change', '[data-platform-checkbox="true"]', function () {
        handlePlatformField($(this), { $form: $form });
    });

    // Handle "Do you sell creations as well?" radio button change for influencer
    $form.on('change', '[data-sell-creations-radio="true"]', function () {
        handleSellCreationsChange($(this), { $form: $form });
    });
}

/**
 * Initialize journey form - sets up initial state and handlers
 * @param {jQuery} $form - Form jQuery object
 * @param {Object} options - Configuration options
 * @param {number} options.currentStep - Current step number (for registration flow)
 * @param {Function} options.onChangeCallback - Optional callback when customer type changes
 */
function initializeJourneyForm($form, options) {
    var opts = options || {};
    var currentStep = opts.currentStep;
    var onChangeCallback = opts.onChangeCallback;

    if (!$form || $form.length === 0) {
        return;
    }

    // Get initial customer type from checked radio button
    var $checkedCustomerType = $form.find('input[name*="customerType"]:checked');
    if ($checkedCustomerType.length > 0) {
        var customerType = $checkedCustomerType.val();
        showJourneyFields(customerType, $form);

        // Handle customerType "other" field if selected
        if (customerType === 'other') {
            handleOtherField($checkedCustomerType, { currentStep: currentStep, $form: $form });
        }
    }

    // Initialize "other" fields visibility after showing journey fields
    requestAnimationFrame(function () {
        initializeOtherFields($form);
    });

    // Set up customer type change handler
    handleCustomerTypeChange($form, {
        currentStep: currentStep,
        onChangeCallback: onChangeCallback
    });

    // Set up common event handlers
    initializeJourneyFormHandlers($form, {
        currentStep: currentStep
    });
}

module.exports = {
    handleOtherField: handleOtherField,
    handlePlatformField: handlePlatformField,
    handleSellCreationsChange: handleSellCreationsChange,
    initializeOtherFields: initializeOtherFields,
    validateOtherFields: validateOtherFields,
    createTempFormForValidation: createTempFormForValidation,
    mapValidationErrors: mapValidationErrors,
    showJourneyFields: showJourneyFields,
    handleCustomerTypeChange: handleCustomerTypeChange,
    initializeJourneyFormHandlers: initializeJourneyFormHandlers,
    initializeJourneyForm: initializeJourneyForm
};

